/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import Script from "next/script";

import { NavigationScrollPaddingFix } from "./NavigationScrollPaddingFix";

interface Props {
	brand: string;
}

export const NavigationScript = ({ brand }: Props): React.JSX.Element => {
	const epicComponentDomain = process.env.EPIC_COMPONENTS_DOMAIN;
	return (
		<>
			<Script
				async
				type="module"
				crossOrigin="anonymous"
				src={`${epicComponentDomain}/navigation/${brand}-navigation.mjs`}
			></Script>
			<NavigationScrollPaddingFix />
		</>
	);
};
